export const QUESTION_COLUMNS = [
  { id: "questionImageUrl", label: "Image", width: "7%", isImage: true },
  { id: "questionText", label: "Question Text", width: "58%" },
  { id: "createdAt", label: "Created Date", width: "20%", isDate: true },
  { id: "actions", width: "15%" },
];
